/**
 * Lazily loads the Razorpay checkout script only when needed.
 * Calling multiple times is safe — the script is only injected once.
 * @returns {Promise<boolean>} true if loaded successfully, false otherwise.
 */
const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

export const loadRazorpay = () => {
    return new Promise((resolve) => {
        // If already loaded, resolve immediately
        if (window.Razorpay) {
            resolve(true);
            return;
        }

        // Check if the script tag already exists (avoids double injection)
        if (document.querySelector(`script[src="${RAZORPAY_SCRIPT_URL}"]`)) {
            // Wait for it to finish loading
            const checkInterval = setInterval(() => {
                if (window.Razorpay) {
                    clearInterval(checkInterval);
                    resolve(true);
                }
            }, 50);
            // Timeout after 10 seconds
            setTimeout(() => {
                clearInterval(checkInterval);
                resolve(false);
            }, 10000);
            return;
        }

        const script = document.createElement('script');
        script.src = RAZORPAY_SCRIPT_URL;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
};
